import * as yup from 'yup';

yup.addMethod(yup.string, 'hostname', function ipv6(message) {
  return this.test('hostname', message, (value) =>
    /^(?!-)([A-Za-z0-9-]{1,63}\.)+[A-Za-z]{2,63}$/.test(value),
  );
});
